import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import style from './ChunkLoadErrorFallback.module.scss?module';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faArrowRotateRight } from '@fortawesome/free-solid-svg-icons/faArrowRotateRight'; 

export function ChunkLoadErrorFallback() {
  return (
    <div className={style.Container}>
      <div className={style.Box} role="alert">
        <div className="d-flex align-items-center justify-content-center gap-2">
          <h1 className={style.Title}>Loading Error </h1>
          <FontAwesomeIcon size="2xl" icon={faTriangleExclamation} bounce />
        </div>

        <p className={style.Message}>
          Part of the application could not be loaded. This sometimes happens
          after an update or due to network problems. Please reload the page.
        </p>

        <button
          className={style.Button}
          onClick={() => window.location.reload()}
        >
          Reload Page  <FontAwesomeIcon icon={faArrowRotateRight} />
        </button>
      </div>
    </div>
  );
}
